import { z } from 'zod';

import { SignupFieldEntrySchema } from './signup-custom-fields.schema';

import { isValidPhoneNumber } from '@kit/ui/phone-input';

import { FullNameSchema } from './full-name.schema';
import { ChildSchema } from './password-sign-up.schema';

/**
 * Email-OTP sign-up: same identity fields as the password sign-up (name, email,
 * phone, children) minus password/repeatPassword/entityName. Verification is via
 * an emailed 6-digit code rather than a password.
 */
export const OtpSignUpSchema = z.object({
    signupFields: z.array(SignupFieldEntrySchema).optional(),
  name: FullNameSchema,
  email: z.string().email(),
  phoneNumber: z
    .string()
    .min(1, 'Phone number is required')
    .refine((value) => isValidPhoneNumber(value), {
      message:
        'Please enter a valid phone number with the correct number of digits',
    }),
  termsAccepted: z.boolean().optional(),
  children: z.array(ChildSchema).max(5).optional().default([]),
});
